import { trackDigitalEvent } from '@sparknz/tracking';

import { StockInfo } from 'journey/checkout/types';
import { Cart } from 'shared/types/cart';
import { buildTrackingCartData } from 'shared/utils/tracking/buildTrackingCartData.utils';

interface TrackInitiateCheckoutSuccessProps {
  cart: Cart;
  isBusiness: boolean;
  stockInfo: StockInfo;
}

export function trackInitiateCheckoutSuccess({
  cart,
  isBusiness,
  stockInfo,
}: TrackInitiateCheckoutSuccessProps) {
  trackDigitalEvent({
    event: 'shop.checkoutAction',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Checkout',
            eventAction: 'shop.checkoutAction',
          },
          attributes: {
            isSuccess: true,
          },
        },
      ],
      cart: buildTrackingCartData({ cart, isBusiness, stockInfo }),
    },
  });
}
